import { QuickAdd } from '@ui/general';
import { takeRandom } from '@sonar-software/sonar-ts-lib';
import { COPY_SONAR_OBJECT_BASE, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef } from 'react';
import { useCreateTag, useCurrentUser } from '@hooks';
export const CreateTag = ({ onFinish }) => {
    const { isProcessing, isSuccessful, request, reset, result } = useCreateTag();
    const { id } = useCurrentUser();
    const onFinishRef = useRef(onFinish);
    onFinishRef.current = onFinish;
    useEffect(() => {
        var _a;
        if (isSuccessful && result) {
            (_a = onFinishRef.current) === null || _a === void 0 ? void 0 : _a.call(onFinishRef, result.sonarObjectTagId);
            reset();
        }
    }, [isSuccessful, reset, result]);
    return (React.createElement(QuickAdd, { onSubmit: (value) => request({
            description: '',
            hexColor: takeRandom(TAG_COLORS),
            name: value === null || value === void 0 ? void 0 : value.trim(),
            ownerIds: [id]
        }), processing: isProcessing, typeLabel: COPY_SONAR_OBJECT_BASE.TAG }));
};
